import BaseModel from '@jgile/laravel-vue/resources/js/models/BaseModel';
import Query from '@jgile/laravel-vue/resources/js/lib/Query';

class Creative extends BaseModel {
    resource() {
        return 'creative';
    }

    constructor(attributes) {
        super(attributes);
    }

    resource() {
        return 'creative';
    }

    share(email, content) {
        return new Query({
            filter: { id: this.id },
        }).post('/api/orders/share/creative', { email: email, content: content });
    }

    setStatus(status) {
        const self = this;

        return this.update({
            status: status,
            status_reason: self.status_reason,
            status_notes: self.status_notes,
        }).then(function () {
            Bus.$emit('reloadOrder');
            Bus.$emit('tableTableRefresh');
        });
    }

    orderItemIds() {
        return [this.order_item_id];
    }

    get needsCreative() {
        if (this.creative_type === 2) {
            return !this.text;
        }

        return !this.getAttribute('media');
    }

    get creative_ids() {
        return [this.id];
    }

    get order_item_ids() {
        return this.orderItemIds();
    }

    get approved() {
        return !this.denied && !this.approvalNeeded && !this.changeRequested;
    }

    get approvalNeeded() {
        return this.status === _.get(vars, 'pageOptions.statuses.none', 'admin_approved');
    }

    get denied() {
        return _.includes(['admin_denied', 'team_denied'], this.status);
    }

    get changeRequested() {
        return _.includes(['admin_change_requested', 'team_change_requested'], this.status);
    }

    get changeApplied() {
        return _.includes(['admin_change_applied', 'team_change_applied'], this.status);
    }
}

export default Creative;
